angular.module('app.directives.checkout').directive('checkoutFinal', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
    },
    controller: function ($scope) {},
    template: `
    <div class="col-xs-12 text-center" ng-show="vm.waitingForFinalization">
      <h3 style="margin-bottom:20px">Please wait while we finalize your account</h3>
      <p class="help-block" style="font-size:1.4em;margin:40px 0;">
        <i class="fa fa-spin fa-spinner"></i> Finalizing
      </p>
      <p class="help-block" style="font-size:16px;margin-bottom:50px">
        Sit tight. It should only take a few more moments while we put the finishing touches on your account...
      </p>
    </div>
    <div class="col-xs-12 text-center" ng-hide="vm.waitingForFinalization">
      <div ng-show="vm.method == 'check' || vm.method == 'po'">
        <h3 style="margin-bottom:20px">Thank you for completing your account setup.</h3>
        <div class="bg-info text-info" style="padding:10px;border-radius:4px;font-size:15px;margin:15px auto;max-width:300px;">
          <p ng-if="vm.method == 'check'">Make checks payable to <strong>BoxCast</strong> and mail to:</p>
          <p ng-if="vm.method == 'po'">
            Send in your purchase order by email to
            <strong><a href="mailto:billing@boxcast.com" target="_blank">billing@boxcast.com</a></strong> or mail to:</p>
            <strong>
              BoxCast<br>
              Attn: Payments Dept<br>
              2401 Superior Viaduct<br>
              Cleveland, OH 44113
            </strong>
          </p>
        </div>
        <p style="font-size:16px">Once your payment is received, your account will be fully activated.</p>
      </div>

      <div ng-hide="vm.method == 'check' || vm.method == 'po'">
        <h3 style="margin-bottom:20px">Welcome to BoxCast! You're now ready to stream!</h3>
        <img src="/img/onboarding-celebrate.png" style="width:40%">
      </div>

      <p style="font-size:16px;margin:15px 100px 30px 100px;">
        If you have any questions, visit our
        <a href="https://support.boxcast.com" target="_blank" style="border-bottom:1px solid;">Support Center</a>
        or connect with one of our live streaming experts. We're always here to help!
      </p>

      <a class="btn btn-primary btn-lg" ng-click="vm.dismiss()" style="margin-bottom:20px">
        Let's Go!
      </a>
    </div>
`,
  };
});



// WEBPACK FOOTER //
// ./app/directives/checkout/checkout-final.js